export enum AUTH_TYPES {
  EMAIL = 'email',
  ENTRA_ID = 'entra_id'
}
